import { useQuery } from '@tanstack/react-query'
import { api } from '../../api'

export interface CheckinPrefill {
  source: string | null
  date: string
  sleep_hours?: number | null
  energy_level?: number | null
  stress_level?: number | null
  readiness_score?: number | null
  hrv_rmssd_ms?: number | null
  resting_hr_bpm?: number | null
}

export function useCheckinPrefill(date: string, enabled = true) {
  return useQuery({
    queryKey: ['checkin', 'prefill', date],
    queryFn: () => api.get<CheckinPrefill>(`/api/checkin/prefill?date=${encodeURIComponent(date)}`),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  })
}
